import React, {Fragment} from 'react';

const Clima = ({resultado}) => {

    const {main, name} = resultado;

    if(!name) return null;

    const kelvin = 273.15;

    return ( 
        <Fragment>
            <div className='text-center mt-5 clima'>
                <h2>El clima de {name} es: </h2>
                <p>{ parseFloat( main.temp - kelvin, 10).toFixed(2)}<span>&#x2103;</span></p>
                <p>Temperatura Máxima: { parseFloat( main.temp_max - kelvin, 10).toFixed(2)} <span>&#x2103;</span></p>
                <p>Temperatura Mínima: { parseFloat( main.temp_min - kelvin, 10).toFixed(2)} <span>&#x2103;</span></p>
                <p>Humedad: {main.humidity} % </p>
            </div>
            
        </Fragment>
     );
}
 
export default Clima;